import { render, staticRenderFns } from "./LapidusAddClass.vue?vue&type=template&id=21edac7a&"
import script from "./LapidusAddClass.vue?vue&type=script&lang=js&"
export * from "./LapidusAddClass.vue?vue&type=script&lang=js&"
import style0 from "./LapidusAddClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports